import { UnitType } from "../types";

export const dynamicScale = (value: number, globalWidth: number) => {
  return (value / 640) * globalWidth;
};

export const convertPixelsCm = (value: number, unit: UnitType) => {
  return unit === "px" ? value : (value * 2.54) / 96;
};

export const convertHexToRgb = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
};

export const randomBetweenNumbers = (
  min: number,
  max: number,
  disableFloor?: boolean,
) => {
  if (disableFloor) {
    return Math.random() * (max - min) + min;
  } else {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
};

const clamp = (input: number, min: number, max: number): number => {
  return input < min ? min : input > max ? max : input;
};

export const mapRange = (
  in_min: number,
  in_max: number,
  out_min: number,
  out_max: number,
  current: number,
): number => {
  const mapped: number =
    ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  return clamp(mapped, out_min, out_max);
};
